/**
* 结束任务，并且把任务信息写入任务表中
*/
<template>
    <span>
        <a @click="openmodel()">结束</a>
        <a-modal :visible="visible" :width="1280" title="任务详情" @ok="okmodel" @cancel="cancelmodel">
            <div>
                <a-alert message="警告" description="任务状态一旦结束,将导致学生后续学生无法完成任务,并且不可重新开起,确认是否结束!" type="warning" show-icon />
                <a-divider></a-divider>
                <a-descriptions title="任务完成情况">
                    <a-descriptions-item label="发布班级数">
                        {{ datainfo.squadmissioncount }}
                    </a-descriptions-item>
                    <a-descriptions-item label="发布人数">
                        {{ datainfo.usermission_count }}
                    </a-descriptions-item>
                    <a-descriptions-item label="已完成人数">
                        {{ datainfo.wcusermissioncount }}
                    </a-descriptions-item>
                    <a-descriptions-item label="最早完成" v-if="datainfo.earliestuserinfo != null">

                        <a-tooltip placement="top">
                            <template slot="title">
                                {{ datainfo.earliestuserinfo.campus_name }}-{{ datainfo.earliestuserinfo.squad_name }}-{{
                                    datainfo.earliestuserinfo.user_name }}
                            </template>
                            <span> {{ moment(datainfo.earliestuserinfo.tj_time * 1000).format('lll') }}
                            </span>
                        </a-tooltip>
                    </a-descriptions-item>
                    <a-descriptions-item label="最晚完成" v-if="datainfo.enduserinfo != null">

                        <a-tooltip placement="top">
                            <template slot="title">
                                {{ datainfo.enduserinfo.campus_name }}-{{ datainfo.enduserinfo.squad_name }}-{{
                                    datainfo.enduserinfo.user_name }}
                            </template>
                            <span> {{ moment(datainfo.enduserinfo.tj_time * 1000).format('lll') }}
                            </span>
                        </a-tooltip>
                    </a-descriptions-item>
                    <a-descriptions-item label="最高分" v-if="datainfo.top_score != null">
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{ datainfo.enduserinfo.campus_name }}-{{ datainfo.enduserinfo.squad_name }}-{{
                                    datainfo.enduserinfo.user_name }}
                            </template>
                            <span> {{ datainfo.top_score.sum_score }}分
                            </span>
                        </a-tooltip>
                    </a-descriptions-item>
                </a-descriptions>
                <a-divider></a-divider>
                <a-button type="danger" block @click="endmission">
                结束
            </a-button>
            <!--   <a-table :dataSource="squaduserlist" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" bordered>
                     <a-table-column key="username" title="姓名" data-index="user_name" />
                        <a-table-column key="campusname" title="校区" data-index="campus_name" />
                    <a-table-column key="gradename" title="年级" data-index="grade_name" />
                    <a-table-column key="squadname" title="班级" data-index="squad_name" />
                 
                    </a-table>
                        <div>总共{{pageinfo.total}}条数据</div> -->


            </div>

        </a-modal>
    </span>
</template>
<script>
import moment from "moment";
export default {
    components: {},
    props: {
        itemdata: {},
    },
    data() {
        return {
            data: [],
            datainfo: {},

            loading: false,
            visible: false,
        };
    },
    mounted() {

    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    selectedRows;
                    //  this.squad_id = selectedRowKeys;
                    // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },

            };
        },
    },
    methods: {
        moment,
        getTableList() {
            this.loading = true;
            this.$axios
                .post("/api/AnalyseInfo/getmission_completion", {
                    data: {
                        mission_id: this.itemdata.id,
                    },
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.datainfo = null;
                    } else {
                        this.datainfo = res.data;
                        this.earliestuserinfo = res.data.earliestuserinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        endmission() {
            this.$axios
                .post("/api/BasicMission/endmisssion", {
                    data: {
                        mission_id: this.itemdata.id,
                    },
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.visible = false;
                        this.$emit('getsquad', true);
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        openmodel() {
            this.visible = true;
            this.getTableList();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
